/**
 * ユーザー権限
 */
export const Role = {
  // admin
  管理者: 1,
  // アナウンス
  アナウンス: 5,
  // 一般
  一般: 10,
} as const;

export type RoleType = typeof Role[keyof typeof Role];
